var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large terms-of-sales-container"
  }, [_c("BackgroundVideo"), _c("div", {
    staticClass: "container-centered small"
  }, [_c("TermsOfSalesComponent")], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };